import { useCallback } from 'react';

import { resetUser, setUserUuid } from '@redux/user';
import { captureException } from '@sentry/browser';
import { useDispatch } from 'react-redux';

export const useB2cAuthEventListener = () => {
  const dispatch = useDispatch();

  const handleSignIn = useCallback(
    (userId: string | undefined) => {
      try {
        if (!userId) {
          return;
        }
        dispatch(setUserUuid(userId));
      } catch (error) {
        captureException(error);
      }
    },
    [dispatch],
  );
  const handleSignOut = useCallback(() => {
    try {
      dispatch(resetUser());
    } catch (error) {
      captureException(error);
    }
  }, [dispatch]);
  return { handleSignIn, handleSignOut };
};
